import { PageLayout, Content } from "aldoo-ra/Layouts"
import ContactPanel from "../ContactPanel"
import ContactPanelPartners from "../ContactPanelPartners"
import Footer from "../Footer"
import Navbar from "../Navbar"
import AldooStore from "aldoo-ra/Store"
import PromoBanner from "./PromoBanner"
import PlatformUrlManager from "./PlatformUrlManager"
import Impact from "../Impact"

/** Store configuration of the aqua site (see DEFAULT_STORE_CONFIG) */
const STORE_CONFIG = {
  // a brand new email creates the account and goes on; existing accounts
  // still open the magic link
  verifyNewUsers: false,
}

export default function Site({ children }) {
  return (
    <PageLayout>
      <PlatformUrlManager />
      <Navbar />
      <Content>{children}</Content>
      <AldooStore config={STORE_CONFIG} />
      <Impact />
      <ContactPanel />
      <ContactPanelPartners />
      <PromoBanner />
      <Footer />
    </PageLayout>
  )
}
